const setCurrentFeature = (state, payload) => {
  state.currentFeature = payload
}
const setAllFeatures = (state, payload) => {
  state.allFeatures = payload
}
const addFeature = (state, payload) => {
  if (!state.allFeatures.includes(payload)) {
    state.allFeatures.push(payload)
  }
}
const removeFeature = (state, payload) => {
  state.allFeatures = state.allFeatures.filter((feature) => {
    if (feature !== undefined) return feature
  })
}
const setFeatureState = (state, payload) => {
  state.featureState = payload
}
const setIsDrawing = (state, payload) => {
  state.isDrawing = payload
}

const setLatLong = (state, payload) => {
  state.latLong = payload
}
const setCurrentMarkers = (state, payload) => {
  state.currentMarkers = payload
}


export default {
  setCurrentMarkers,
  setLatLong,
  setCurrentFeature,
  setAllFeatures,
  addFeature,
  removeFeature,
  setFeatureState,
  setIsDrawing
}
